import {GuideStep} from '@blesk-frontend/api';

/**
 *
 * @param steps
 */
export const getStepWithImage = (steps: GuideStep[]): GuideStep | null => {
  return steps.find((step) => step.payload.src.original || step.payload.src.edited) || null;
};
